<!-- <ngx-loading [show]="loading"></ngx-loading> -->
<!-- {{showSuccessScreen}} -->
<div class='row sendreviewinvite_sec' style="background:#f8f8fd;" *ngIf="!showPageNotFound && !showSuccessScreen">
  <div class='col-12'>
    <div class="card card-border-radius box_shadow_color">
      <div class="col-md-12 col-12" style="padding:16px">
        <div class="alert alert-warning" *ngIf="is_product_blocked ">
          <strong>Warning!</strong> - you can no longer book appointments on this link please call this number for
          further support. <a [href]="'tel:'+ownerNumber">{{ownerNumber}}</a>
        </div>
        <div class="row">
          <div class="col-md-12 col-col-sm-12 col-xs-12 thankyoureview ">
            <span><img *ngIf="businessLogo" [src]="businessLogo" class="img-responsive-logo">
              <span class="bus_name_review">{{ businessName }}</span>
              <p class="my-2">{{businessOutletName}}</p>
            </span>
          </div>
        </div>
        <div class="row d-flex justify-content-between mx-auto">
          <div class="col-md-4 order-1 order-md-0">
            <div class="btn-group">
              <div class="btn btn-primary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
                (viewDateChange)="closeOpenMonthViewDay($event)">
                Previous
              </div>
              <div class="btn btn-secondary bg-white text-dark" mwlCalendarToday [(viewDate)]="viewDate"
                (viewDateChange)="closeOpenMonthViewDay($event, true)">
                Today
              </div>
              <div class="btn btn-primary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                (viewDateChange)="closeOpenMonthViewDay($event)">
                Next
              </div>
            </div>
          </div>
          <div class="col-8 col-md-4 text-md-right text-lg-center">
            <!-- <span>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3> -->
            <p class="mb-2">{{ viewDate | calendarDate:('dayViewTitle') }}</p>
          </div>
          <div class="col col-md-4 text-right"
            [style.visibility]="(selectedDate == currentDate) ? 'visible' : 'hidden'">
            {{timeZone | async | date: 'shortTime'}}
          </div>
        </div>
        <br />
        <div>
          <!-- [activeDayIsOpen]="activeDayIsOpen" -->
          <!-- (eventClicked)="handleEvent($event.event)" (eventTimesChanged)="eventTimesChanged($event)" -->
          <mwl-calendar-month-view class="w-100" [viewDate]="viewDate" [refresh]="refresh" (dayClicked)="dayClicked($event.day)"
            (beforeViewRender)="beforeMonthViewRender($event)">
          </mwl-calendar-month-view>
        </div>
        <footer class="mt-4">
          <div class="col-md-12 col-col-sm-12 col-xs-12">
            <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 poweredBy">
              <p>Powered by</p>
        <a href="https://www.zceppa.com" target="_blank">
          <img src="assets/images/zceppadark.svg" class="img-responsive">
        </a>
            </div>
          </div>
        </footer>


      </div>


    </div>
  </div>
</div>
<div class="container expiresec mt-4 h-100" *ngIf="showPageNotFound">
  <div class="row align-items-center h-100 expiresec">
    <div class="col-6 mx-auto">
      <div class="expiretext text-center">
        <h2 class="pb-3">Error!</h2>
        <img src="assets/gifs/exclamation-mark.png" width="80px">
        <p class="pt-3">The link has expired</p>
      </div>
    </div>
  </div>
  <footer>
    <div class="col-md-12 col-col-sm-12 col-xs-12">
      <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 poweredBy">
        <p>Powered by</p>
        <a href="https://www.zceppa.com" target="_blank">
          <img src="assets/images/zceppadark.svg" class="img-responsive">
        </a>
      </div>
    </div>
  </footer>
</div>
<div class="show-success-main" *ngIf="showSuccessScreen">
  <div class="inner-success pt-5">
    <div class=" col-md-8 col-12 mx-auto">
      <div class="expiretext text-center">
        <img src="assets/images/appointment-booked-80-px.svg" width="80px">
        <!-- <img src="../../assets/images/appointment-booked-80-px.svg" width="80px"> -->
        <p class="pt-3 heading-success">You have successfully booked the appointment with</p>
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12 thankyoureview mt-2">
            <span><img *ngIf="businessLogo" [src]="businessLogo" class="img-responsive">
              <span class="bus_name_review">{{ businessName }}</span>
              <p class="my-2">{{businessOutletName}}</p>
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center mb-4 pb-2" *ngIf="appointment_id_show != null">
          <span class="appointment-info mr-2" style="font-size: 13px;">Appointment ID</span>
          <span class="query-text">{{appointment_id_show}}</span>
        </div>
        <div class="d-flex justify-content-center align-items-center my-3 ">
          <img class="mr-2" src="assets/images/calendar-24-px.svg" alt="">
          <span class="appointment-info">{{date}}</span>
        </div>
        <div class="d-flex justify-content-center align-items-center my-3 ">
          <img class="mr-2" src="assets/images/slot-24-px.svg" alt="">
          <span class="appointment-info">{{slot_time}}</span>
        </div>
        <div class="d-flex justify-content-center align-items-center my-3 "
          *ngIf="!autoAssignTeamMember && (tag_team_member_setting == 'Both' || tag_team_member_setting == 'Consumer')">
          <img class="mr-2" src="assets/images/consultant-24-px.svg" alt="">
          <span class="appointment-info" style="text-transform: capitalize;">{{teamMemberSelectedName}}</span>
        </div>
        <p class="query-text">You will receive a confirmation mail/SMS for your booking. <br> If you have any queries,
          please contact
          <span>
            <a [href]="'tel:'+ownerNumber">{{ownerNumber}}</a>
            <!-- {{ownerNumber}} -->
          </span>
        </p>
      </div>
    </div>
    <div class="text-center">
      <button type="submit" class="btn btn-secondary btn-sm reviwadd" (click)="setCurrentDateACloseModel()">Got
        It</button>
    </div>
  </div>
</div>


<ng-template #addAppointment>
  <div class='row review-invite w-100'>
    <div class='col-lg-12 col-md-12 col-sm-12 left-container popsendview'>
      <button type="button" class="close" aria-label="Close" (click)="onCloseAppointmentModal()">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class='col-lg-12 col-md-12 col-sm-12 popsendviewright'>
        <div class="row">
          <div class="col-md-12 col-col-sm-12 col-xs-12 thankyoureview mt-2 mb-0">
            <span><img [src]="businessLogo" *ngIf="businessLogo" class="img-responsive">
              <span class="bus_name_review">{{ businessName }}</span>
              <p class="my-2">{{businessOutletName}}</p>
            </span>
            <div class='heading  col-12 '>Add Appointment</div>
          </div>
        </div>
        <div class="wrapper-progressBar row">
          <ul class="progressBar col" style="box-shadow: none !important;">
            <li class="" (click)="checkValidToProceed('step_1')"
              [class.active]="selected_tab_circle == 'step_1' ||  selected_tab_circle == 'step_2' || selected_tab_circle == 'share' "
              [class.is-current]="selected_tab_circle == 'step_1'">
              <span class="seleted-process"
                [ngStyle]="{'color': selected_tab_circle == 'step_1' ? '#03c0c2' : '#9b9b9b', 'font-weight' : selected_tab_circle == 'step_1' ? 'bold' : 'normal'}">
                STEP 1</span>
            </li>
            <li class="" (click)="checkValidToProceed('step_2')"
              [class.active]="selected_tab_circle == 'step_2' || selected_tab_circle == 'share' "
              [class.is-current]="selected_tab_circle == 'step_2'">
              <span class="seleted-process"
                [ngStyle]="{'color': selected_tab_circle == 'step_2' ? '#03c0c2' : '#9b9b9b' , 'font-weight' : selected_tab_circle == 'step_2' ? 'bold' : 'normal'}">STEP
                2</span>
            </li>
          </ul>
        </div>
        <div class="main-wrapper" *ngIf="selected_tab_circle == 'step_1'">
          <div class="label-wrapper">
            <p class="heading-label">Date</p>
            <span class="date">{{selectedDate}}</span>
          </div>
          <div class="label-wrapper">
            <p class="heading-label">Select Slot</p>
            <div class="input-group  w-100 templates_list tags_list">
              <ul class="mb-0">
                <ng-container *ngFor="let slot of slotsAvailable;let i = index">

                  <li>
                    <div class="custom-control custom-checkbox" [class.selected]="slot.hours === slotSelected">
                      <input type="checkbox" class="custom-control-input" [name]="slot.hours" [value]="slot.hours"
                        [id]="slot.hours" [checked]="slot.hours" [(ngModel)]="slotSelected"
                        [ngModelOptions]="{ standalone: true }" (ngModelChange)="onSlotChange(slot.hours)">
                      <label class="custom-control-label title" [for]="slot.hours">{{ show12Hours(slot.hours) }}</label>
                    </div>
                  </li>

                </ng-container>
              </ul>

            </div>
          </div>
          <ng-container *ngIf="!autoAssignTeamMember">
            <div class="label-wrapper"
              *ngIf="tag_team_member_setting == 'Both' || tag_team_member_setting == 'Consumer'">
              <p class="heading-label">{{tagTeamMemberDisplayName == null ? 'Tag Team Member' :
                tagTeamMemberDisplayName}}
              </p>
              <div class="input-group w-100 templates_list tags_list">
                <ul class="mb-0">
                  <ng-container *ngFor="let val of managerList;let i = index">
                    <li>
                      <div class="custom-control custom-checkbox"
                        [class.selected]="val.manager_id === teamMemberSelected">
                        <input type="checkbox" class="custom-control-input" [name]="val.manager_id"
                          [value]="val.manager_id" [id]="val.manager_id" [checked]="val.manager_id"
                          [(ngModel)]="teamMemberSelected" [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="teamMemberSelectedChange(val)">
                        <label class="custom-control-label title" style="top: 0;"
                          [for]="val.manager_id">{{val.manager_first_name}}&nbsp;{{val.manager_last_name}}</label>
                      </div>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
          </ng-container>
          <div *ngIf="isAppointmentFlexFieldEnabled || isCategeryEnabled" class="d-flex" style="flex-wrap: wrap;">
            <ng-container *ngIf="isAppointmentFlexFieldEnabled">
              <div *ngFor="let field of addAppointmentFlexFieldList" class="flex-field-wrapper ">
                <ng-container *ngIf=" field.name !== ''">
                  <div class="label-wrapper ">
                    <p class="heading-label">{{field.name | titlecase}}</p>
                    <!-- <div class="input-group  col-12 p-0">
                      <input class="form-control" [id]="field.name" [(ngModel)]="field.content"
                        [ngModelOptions]="{standalone: true}" placeholder="{{field.name | titlecase}}" name="field.name"
                        [ngClass]="{'red-error-class' : stepOneSubmitClicked && field.required && (field.content == '' || field.content == null)}">
                    </div> -->
                    <div class="input-group  col-12 p-0" *ngIf="field.input_type == 'Text'">
                      <input class="form-control" [id]="field.name" [(ngModel)]="field.content"
                        [ngModelOptions]="{standalone: true}" placeholder="{{field.name | titlecase}}" name="field.name"
                        [ngClass]="{'red-error-class' : stepOneSubmitClicked && field.required && (field.content == '' || field.content == null)}"
                        required>
                    </div>
                    <div class="input-group  col-12 p-0" *ngIf="field.input_type == 'Toggle'">
                      <!-- <ui-switch  color="#03c0c2" [id]="field.field_id"
                      style="top: 5px;height: 24px;" [(ngModel)]="field.content" [checked]="field.content"
                      [ngModelOptions]="{standalone: true}" >
                    </ui-switch> -->
                      <label class="switch mb-0">
                        <input type="checkbox" id="togBtn" [(ngModel)]="field.content"
                          [ngModelOptions]="{standalone: true}">
                        <div class="slider round mt-0">
                          <!--ADDED HTML -->
                          <span class="on">Enabled</span><span class="off">Disabled</span>
                          <!--END-->
                        </div>
                      </label>
                      <!-- [ngClass]="{'red-error-class' : stepOneSubmitClicked && field.required && (field.content == '' || field.content == null)}" -->
                    </div>
                    <div class="input-group  col-12 p-0" *ngIf="field.input_type == 'Date'">
                      <input class="form-control" placeholder="{{field.name | titlecase}}" [style.width]="'100%'"
                        [(ngModel)]="field.content" [ngModelOptions]="{standalone: true}" [owlDateTimeTrigger]="tRange2"
                        [owlDateTime]="tRange2"
                        [ngClass]="{'red-error-class' : stepOneSubmitClicked && field.required && (field.content == '' || field.content == null)}">
                      <owl-date-time [pickerType]="'calendar'" [startAt]="field.content ? null : startAt" #tRange2>
                      </owl-date-time>
                    </div>
                    <div class="input-group  col-12 p-0" *ngIf="field.input_type == 'Number'">
                      <input class="form-control" [id]="field.name" [(ngModel)]="field.content" type="number" min="0"
                        [ngModelOptions]="{standalone: true}" placeholder="{{field.name | titlecase}}" name="field.name"
                        [ngClass]="{'red-error-class' : stepOneSubmitClicked && field.required && (field.content == '' || field.content == null) || isNan(field.content)}"
                        required>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>

            <div class="flex-field-wrapper mr-0">
              <div class="label-wrapper " *ngIf="isCategeryEnabled">
                <p class="heading-label">Category</p>
                <div class="input-group  col-12 p-0">
                  <select [(ngModel)]="CategorySelected" [ngModelOptions]="{standalone: true}" class="form-control"
                    placeholder="Select Category">
                    <option class="ng-tns-c5-1" value="" selected>Select Category</option>
                    <ng-container *ngFor="let val of categoryList; let i = index;">
                      <option [value]="val.category_id"> {{val.category_name}}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="row form-group col-md-6 col-12" *ngIf="isCategeryEnabled">
            <label class="col-md-3 col-12 text-md-right">Category</label>
            <div class="input-group col-md-9 col-12">
              <select [(ngModel)]="CategorySelected" [ngModelOptions]="{standalone: true}" class="form-control"
                placeholder="Select Category">
                <option class="ng-tns-c5-1" value="" selected>Select Category</option>
                <ng-container *ngFor="let val of categoryList; let i = index;">
                  <option [value]="val.category_id"> {{val.category_name}}</option>
                </ng-container>
              </select>
            </div>
          </div> -->


          <div class="row form-group col-md-6 col-12  mt-2" *ngIf="showMeetingLink && google == 'connected'">
            <label for="name" class="Opt-for-Video-Confer ">Enable Video Conference</label>
            <div class="input-group col-md-3 col-12 pl-md-1 pl-0">
              <!-- <ui-switch color="#ffffff" class="px-2" style="top: 0;" [(ngModel)]="enableMeetingLink"
                (ngModelChange)="enable_meeting_link($event)" [ngModelOptions]="{standalone: true}"></ui-switch> -->
              <label class="switch mb-0">
                <!-- [ngClass]="[member.designation === 'Owner' ? 'disable-switch' : 'switch']" -->
                <input type="checkbox" id="togBtn" [(ngModel)]="enableMeetingLink"
                  (ngModelChange)="enable_meeting_link($event)" [ngModelOptions]="{standalone: true}">
                <div class="slider round mt-0">
                  <!--ADDED HTML -->
                  <span class="on">Enabled</span><span class="off">Disabled</span>
                  <!--END-->
                </div>
              </label>
            </div>
          </div>
          <div class="text-center">
            <button type="submit" class="btn btn-secondary btn-sm reviwadd"
              (click)="checkValidToProceed('step_2')"><span><img src="assets/images/proceed-continue.svg"
                  alt="">&nbsp;&nbsp;Continue</span></button>
          </div>
        </div>
        <ng-container *ngIf="selected_tab_circle == 'step_2'">
          <div class="top-step-two-wrapper  col-md-9 col-12">
            <!-- <img src="/../..assets/images/calendar-24-px.svg" alt=""> -->
            <div class="icon-wrapper">
              <img src="assets/images/calendar-24-px.svg" alt="" class="top-img-fix">
              <span>{{selectedDate}}</span>
            </div>
            <div class="icon-wrapper">
              <img src="assets/images/slot-24-px.svg" alt="" class="top-img-fix">
              <span>{{show12Hours(slotSelected)}}</span>
            </div>
            <!-- pt-sm-0 pt-2 -->
            <div class=" icon-wrapper"
              *ngIf="!autoAssignTeamMember && (tag_team_member_setting == 'Both' || tag_team_member_setting == 'Consumer')">
              <img class="tag-icon" src="assets/images/consultant-24-px.svg" alt="" class="top-img-fix">
              <!-- <img src="../../assets/images/consultant-24-px.svg" alt=""> -->
              <span style="text-transform: capitalize;">{{teamMemberSelectedName}}</span>
            </div>
          </div>
          <div class="main-wrapper-step-2">
            <form (ngSubmit)="onSubmitAppointment(appointmentForm)" #appointmentForm="ngForm">
              <div class="d-flex mobile-view-wrap">
                <div class="label-wrapper name-wrapper ">
                  <p class="heading-label">Name</p>
                  <div class="input-group   p-0">
                    <!-- <input id="name" [disabled]="action === 'edit'" class="form-control" placeholder="Name" name="name"
                      ngModel #custName="ngModel" required
                      [ngClass]="{'red-error-class' : addAppSubmitClicked && custName.invalid}"> -->
                    <input id="name" [disabled]="action === 'edit'" class="form-control" placeholder="Name"
                      [(ngModel)]="appointment_cust_name" [ngModelOptions]="{standalone: true}" required
                      [ngClass]="{'red-error-class' : addAppSubmitClicked && appointment_cust_name == ''}">
                  </div>
                </div>
                <div class="label-wrapper  name-wrapper ">
                  <p class="heading-label">Phone Number</p>
                  <div class="input-group   p-0">
                    <!-- <input class="form-control" [disabled]="action === 'edit'" placeholder="Phone Number"
                      name="phoneNumber" pattern="[0-9]*" minlength="10" maxlength="10" required
                      [ngClass]="{'red-error-class' : addAppSubmitClicked && phoneNumber.invalid}" ngModel
                      #phoneNumber="ngModel"> -->
                    <input class="form-control" [disabled]="action === 'edit'" placeholder="Phone Number"
                      pattern="[0-9]*" minlength="10" maxlength="10" required [(ngModel)]="appointment_phone_number"
                      [ngModelOptions]="{standalone: true}"
                      [ngClass]="{'red-error-class' : addAppSubmitClicked && appointment_phone_number == ''}">
                  </div>
                </div>
                <div class="label-wrapper  name-wrapper mr-0 ">
                  <p class="heading-label">Email</p>
                  <div class="input-group   p-0">
                    <!-- <input class="form-control" [disabled]="action === 'edit'" placeholder="Phone Number"
                      name="phoneNumber" pattern="[0-9]*" minlength="10" maxlength="10" required
                      [ngClass]="{'red-error-class' : addAppSubmitClicked && phoneNumber.invalid}" ngModel
                      #phoneNumber="ngModel"> -->
                    <input type="email" #useremail="ngModel" email name="email" class="form-control"
                      placeholder="Email ID" [required]="notificationChannel == 'EMAIL'" [(ngModel)]="emailID"
                      [ngClass]="{'red-error-class' : addAppSubmitClicked && useremail.errors && useremail.errors.required || useremail.errors?.email}">
                  </div>
                  <div *ngIf="useremail.errors && useremail.errors?.email" class="invalid-feedback">
                    <p class="mb-1">Email ID is not valid.</p>
                  </div>
                </div>
              </div>

              <div class="label-wrapper  ">
                <p class="heading-label">Add Note ( If any )</p>
                <div class="input-group   p-0">
                  <textarea name="notes" rows="3" class="form-control notes-textarea"
                    placeholder="Please mention if you have any special requirement" maxlength="150"
                    [(ngModel)]="appointment_notes"></textarea>

                </div>
                <p class="char-left">{{150 - appointment_notes?.length}} Characters Left</p>
              </div>
            </form>



            <!-- *ngIf="whatsAppConnected === 'true' && is_template_approved" -->
            <div class="row form-group col-md-6 col-12  mt-2">
              <label for="name" class="Opt-for-Video-Confer">You will receive notifications on
                WhatsApp.</label>
              <div class="input-group col-md-1 col-12 pl-1">
                <div class="input-group col-md-3 col-12 pl-1">
                  <!-- <ui-switch color="#03c0c2" [(ngModel)]="optionForWhatsApp" [ngModelOptions]="{standalone: true}">
                  </ui-switch> -->
                  <label class="switch mb-0">
                    <input type="checkbox" id="togBtn" [(ngModel)]="optionForWhatsApp"
                      [ngModelOptions]="{standalone: true}">
                    <div class="slider round mt-0">
                      <!--ADDED HTML -->
                      <span class="on">Enabled</span><span class="off">Disabled</span>
                      <!--END-->
                    </div>
                  </label>
                </div>
              </div>
              <!-- <label class="Opt-for-Video-Confer col-12 p-0" style="color: #9b9b9b;">You will receive notifications on
                WhatsApp.</label> -->
            </div>
            <div class="text-center">
              <button class="btn btn-secondary btn-sm reviwadd" style="background-color: #9b9b9b;"
                (click)="checkValidToProceed('step_1')"><span><img src="assets/images/go-back.svg"
                    alt="">&nbsp;&nbsp;Previous</span></button>
              <button type="submit" class="btn btn-secondary btn-sm reviwadd" [disabled]='disabled_till_response'
                (click)="onSubmitAppointment(appointmentForm)"><span><img src="assets/images/send1.svg"
                    alt="">&nbsp;&nbsp;Submit</span></button>
              <!-- <button type="submit" class="btn btn-secondary btn-sm reviwadd" (click)="continueStepTwo()">Submit</button> -->
            </div>
          </div>
        </ng-container>

        <form class="modalreviewadd addsingleclient" #appointmentForm="ngForm">
          <!-- <div class='col-lg-12 col-md-12 col-sm-6 right-container'> -->
          <!-- <div class="row sinvite"> -->

          <!-- <div class="form-group row w-100 notes-container">
                <span class="col-12 col-md-2 col-lg-1 text-md-right">Slots</span>
                <div class="input-group col-12 col-md-10 w-100 templates_list tags_list">
                  <ul>
                    <ng-container *ngFor="let slot of slotsAvailable;let i = index">

                      <li>
                        <div class="custom-control custom-checkbox" [class.selected]="slot.hours === slotSelected">
                          <input type="checkbox" class="custom-control-input" [name]="slot.hours" [value]="slot.hours"
                            [id]="slot.hours" [checked]="slot.hours" [(ngModel)]="slotSelected"
                            [ngModelOptions]="{ standalone: true }" (ngModelChange)="onSlotChange(slot.hours)">
                          <label class="custom-control-label title" [for]="slot.hours">{{ slot.hours }}</label>
                        </div>
                      </li>

                    </ng-container>
                  </ul>

                </div>
              </div> -->
          <!-- <div class="form-group row w-100 notes-container"
                *ngIf="tag_team_member_setting == 'Both' || tag_team_member_setting == 'Consumer'">
                <label class="col-12 col-md-2 col-lg-1 text-md-right">Tag Team Member</label>
              </div> -->
          <!-- <div class="form-group row w-100 notes-container" *ngIf="tag_team_member_setting == 'Both' || tag_team_member_setting == 'Consumer'">
                <label class="col-12 col-md-2 col-lg-1 text-md-right">{{tagTeamMemberDisplayName == null ? 'Tag Team Member' : tagTeamMemberDisplayName}}</label>
                 <span class="col-12  col-md-2 col-md-1 text-md-left">Slots</span> -->
          <!-- <div class="input-group col-12 col-md-10 w-100 templates_list tags_list">
                  <ul>
                    <ng-container *ngFor="let val of managerList;let i = index">
                      <li>
                        <div class="custom-control custom-checkbox"
                          [class.selected]="val.manager_id === teamMemberSelected">
                          <input type="checkbox" class="custom-control-input" [name]="val.manager_id"
                            [value]="val.manager_id" [id]="val.manager_id" [checked]="val.manager_id"
                            [(ngModel)]="teamMemberSelected" [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="teamMemberSelectedChange(val.manager_id)">
                          <label class="custom-control-label title" style="top: 0;"
                            [for]="val.manager_id">{{val.manager_first_name}}&nbsp;{{val.manager_last_name}}</label>
                        </div>
                      </li>
                    </ng-container>
                  </ul>
                </div> -->
          <!-- </div>  -->
          <!-- <div class="row form-group col-md-6 col-12">
                <label for="name" class="col-md-3 col-12 text-md-right">Name</label>
                <div class="input-group col-md-9 col-12">
                  <input id="name" [disabled]="action === 'edit'" class="form-control" placeholder="Name" name="name"
                    ngModel #custName="ngModel" required
                    [ngClass]="{'red-error-class' : addAppSubmitClicked && custName.invalid}">
                </div>
              </div>
              <div class="row form-group col-md-6 col-12">
                <label for="name" class="col-md-3 col-12 text-md-right">Phone</label>
                <div class="input-group col-md-9 col-12">
                  <input class="form-control" [disabled]="action === 'edit'" placeholder="Phone Number"
                    name="phoneNumber" pattern="[0-9]*" minlength="10" maxlength="10" required
                    [ngClass]="{'red-error-class' : addAppSubmitClicked && phoneNumber.invalid}" ngModel
                    #phoneNumber="ngModel">
                </div>
                <div *ngIf="!phoneNumber.valid && phoneNumber.touched" class="invalid-feedback">
                  <p>Number is not in correct format.</p>
                </div>
              </div>
              <div class="row form-group col-md-6 col-12">
                <label class="col-md-3 col-12 text-md-right">Date</label>
                <div class="input-group col-md-9 col-12">
                  <input class="form-control" placeholder="Date" name="Date" [value]="selectedDate" disabled>
                </div>
              </div>
              <div class="row form-group col-md-6 col-12">
                <label class="col-md-3 col-12 text-md-right">Time</label>
                <div class="input-group col-md-9 col-12">
                  <input class="form-control" placeholder="Slot" name="Slot" [value]="slotSelected" disabled>
                </div>
              </div>
              <div class="row form-group col-md-6 col-12" *ngIf="isCategeryEnabled">
                <label class="col-md-3 col-12 text-md-right">Category</label>
                <div class="input-group col-md-9 col-12">
                  <select [(ngModel)]="CategorySelected" [ngModelOptions]="{standalone: true}" class="form-control"
                    placeholder="Select Category">
                    <option class="ng-tns-c5-1" value="" selected>Select Category</option>
                    <ng-container *ngFor="let val of categoryList; let i = index;">
                      <option [value]="val.category_id"> {{val.category_name}}</option>
                    </ng-container>
                  </select>
                </div>
              </div>


              <div class="row form-group col-md-6 col-12" *ngIf="isCategeryEnabled">
              </div>

              <ng-container *ngIf="isAppointmentFlexFieldEnabled">
                <ng-container *ngFor="let field of addAppointmentFlexFieldList">
                  <ng-container *ngIf=" field.name !== ''">
                    <div class="row form-group col-md-6 col-12">
                      <label class="col-md-3 col-12 text-md-right"> {{field.name | titlecase}}
                      </label>
                      <div class="input-group col-md-9 col-12">
                        <input class="form-control" [id]="field.name" [(ngModel)]="field.content"
                          [ngModelOptions]="{standalone: true}" placeholder="{{field.name | titlecase}}"
                          name="field.name"
                          [ngClass]="{'red-error-class' : addAppSubmitClicked && field.required && (field.content == '' || field.content == null)}"
                          required>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>


              <div class="form-group row w-100 notes-container">
                <label for="note" class="col-12 col-md-2 col-lg-1 text-md-right">Notes </label>
                <div class="input-group col-12 col-md-10 w-100">
                  <div class="w-100">
                    <textarea name="notes" rows="3" class="form-control notes-textarea"
                      placeholder="Please add details/requirements of your appointment including any special instructions."
                      maxlength="150" ngModel #notes="ngModel"></textarea>
                  </div>
                  <p> Characters Remaining {{150 - notes.value?.length}}</p>
                </div>
                <div>
                </div>
              </div>
              <div class="row form-group col-md-6 col-12" *ngIf="showMeetingLink && google == 'connected'">
                <label for="name" class="col-md-3 col-12 text-md-right">Enable Video Conference</label>
                <div class="input-group col-md-9 col-12 pl-1">
                  <ui-switch color="#03c0c2" class="px-2" style="top: 0;" [(ngModel)]="enableMeetingLink"
                    (ngModelChange)="enable_meeting_link($event)" [ngModelOptions]="{standalone: true}"></ui-switch>
                </div>
              </div>
              <div class="row w-100 form-group" *ngIf="whatsAppConnected === 'true' && is_template_approved">
                <label for="note" class="Opt-in-container text-md-right">Opt-in for WhatsApp </label>
                <div class="input-group col-md-1 col-12">
                  <ui-switch color="#03c0c2" [(ngModel)]="optionForWhatsApp" [ngModelOptions]="{standalone: true}">
                  </ui-switch>
                </div>
                <label class="input-group col-md-6 col-12">You will receive notifications on WhatsApp.</label>
              </div>

 -->



          <!-- <div class="input-group col-md-6 col-12">
              </div>
              <div class="row  col-md-12 col-12">
                <ul class="col-12 list-inline pull-right reviwinvitbtns">
                  <li>
                    <button type="submit" class="btn btn-secondary btn-sm reviwadd"
                      [disabled]='disabled_till_response'>Submit</button>
                  </li>
                </ul>
              </div> -->
          <!-- </div> -->
          <!-- </div> -->

        </form>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #noSlotsAvailable let-modal>
  <div class="modal-body locat_pop">
    <p class="heading d-block">No slots available for <b>{{ noSlotsAvailablePopupDate }}</b>. Please click on a
      different date
      to book.</p>
  </div>

  <div class="modal-footer" style="border-top: none">
    <button type="button" class="btn btn-primary btn-sm reviwadd" (click)="modal.close('Close click')">Ok</button>
  </div>
</ng-template>
<ng-template #creditsExhaustedModal let-modal>
  <div class="modal-body locat_pop">
    <!-- <p class="heading">You cannot book an appointment via this link. Please contact {{ownerNumber}} for more info.</p> -->
    <p class="heading d-block">Please contact {{businessName}} at {{ownerNumber}} for booking.</p>
  </div>

  <div class="modal-footer" style="border-top: none">
    <button type="button" class="btn btn-primary btn-sm reviwadd" (click)="modal.close('Close click')">Ok</button>
  </div>
</ng-template>

<!-- <ng-template #editAppointment>
  <div class='row review-invite w-100'>
    <div class='col-lg-12 col-md-12 col-sm-12 left-container popsendview'>
      <button type="button" class="close" aria-label="Close" (click)="onCloseEditAppointmentModal()">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class='col-lg-12 col-md-12 col-sm-12 popsendviewright'>
        <form class="modalreviewadd addsingleclient" (ngSubmit)="onSubmitEditAppointment()" #appointmentForm="ngForm">
          <div class='col-lg-12 col-md-12 col-sm-12 right-container'>
            <div class="row sinvite">
              <p class='heading pl-2ccol-12'
                [ngClass]="{'col-sm-4': tagTeamMemberSetting, 'col-12': !tagTeamMemberSetting}">Edit Appointment</p>
              <div class="row col-12 col-sm-8 form-group pr-2" *ngIf="tagTeamMemberSetting">
                <label class="text-sm-right col-12 col-sm-6" style="font-size: 16px;color:#3D3D55">Tag Team
                  Member</label>
                <div class="input-group  col-12 col-sm-6">
                  <select [(ngModel)]="teamMemberSelected" [ngModelOptions]="{standalone: true}" class="form-control">
                    <option class="ng-tns-c5-1" value="" disabled selected>Select Team Member</option>
                    <ng-container *ngFor="let val of managerList; let i = index;">
                      <option [value]="val.manager_id"> {{val.manager_first_name}}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
              <div class="row form-group col-md-6 col-12">
                <label for="name" class="col-md-3 col-12">Name</label>
                <div class="input-group col-md-9 col-12">
                  <input id="name" [disabled]="action === 'edit'" class="form-control" placeholder="Name" name="name"
                    [ngModel]="name" required>
                </div>
              </div>
              <div class="row form-group col-md-6 col-12">
                <label for="name" class="col-md-3 col-12">Phone</label>
                <div class="input-group col-md-9 col-12">
                  <input class="form-control" [disabled]="action === 'edit'" placeholder="Phone Number"
                    name="phoneNumber" pattern="[0-9]*" minlength="10" maxlength="10" required [ngModel]="phoneNumber">
                </div>
                <div *ngIf="!phoneNumber.valid && phoneNumber.touched" class="invalid-feedback">
                  <p>Number is not in correct format.</p>
                </div>
              </div>
              <div class="row form-group col-md-6 col-12">
                <label class="col-md-3 col-12">Date</label>
                <div class="input-group col-md-9 col-12">
                  <input class="form-control" placeholder="Date" name="Date" [ngModel]="selectedDate" disabled>
                </div>
              </div>
              <div class="row form-group col-md-6 col-12">
                <label class="col-md-3 col-12">Time</label>
                <div class="input-group col-md-9 col-12">
                  <input class="form-control" placeholder="Slot" name="Slot" [ngModel]="availableSlot" disabled>
                </div>
              </div>
              <div class="form-group row w-100 notes-container">
                <label for="note" class="col-12 col-md-2 col-lg-1">Notes</label>
                <div class="input-group col-12 col-md-10 w-100">
                  <div class="w-100">
                    <textarea name="notes" rows="3" class="form-control notes-textarea" [(ngModel)]="notes"
                      placeholder="Add Notes" maxlength="150"></textarea>
                  </div>
                  <p> Characters Remaining {{150 - notes?.length}}</p>
                </div>
              </div>

              <div class="row form-group col-md-12 col-12">
                <ul class="col-12 list-inline pull-right reviwinvitbtns">
                  <li>
                    <button type="submit" [disabled]="appointmentForm.invalid"
                      class="btn btn-secondary btn-sm reviwadd">Submit</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</ng-template> -->
<!-- <ng-template #deleteAppointment let-modal>
  <div class="modal-body locat_pop">
    <button style="z-index: 99999;" type="button" class="close" aria-label="Close"
      (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
    <p class="heading">Are you sure want to cancel the appointment?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-sm reviwadd" (click)="deleteSelectedAppointment()">Yes</button>
    <button type="button" class="btn btn-primary btn-sm reviwadd" (click)="modal.close('Close click')">No</button>
  </div>
</ng-template> -->
